import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';
import { Text } from '../../../../common/text/Text';
import { ButtonCustom } from '../../../../common/button/button';
import { Loader } from '../../../../common/loader/loader';
import { Lozenge } from '../../../../common/lozenge/Lozenge';
import { debounce } from '../../../../searchcontext/adapters/primary/debounce';
import { isClaimSaisineReady } from '../../../domain/saisine';

const CreateSaisine = ({
  eligibleClaims, loading, search, create,
}) => {
  const [text, setText] = useState('');

  const debouncedSearch = useMemo(() => debounce((value) => search(null, value), 300), [search]);

  const onChange = (event) => {
    setText(event.target.value);
    debouncedSearch(event.target.value);
  };

  return (
    <PanelContainer>
      <Text color="secondary" variant="body2">
        Choisir le dossier de départ : il verrouille la juridiction et la compagnie de la saisine,
        et sa date de vol ancre la fenêtre de 30 jours.
        Seuls les dossiers en statut « MeD envoyée » ou « Saisine à envoyer », hors saisine et sous 5 000 € sont proposés.
      </Text>
      <SearchInput
        type="text"
        placeholder="Rechercher par identifiant AH ou référence de réservation"
        value={text}
        onChange={onChange}
      />
      {loading && <Loader size={24} />}
      {!loading && eligibleClaims.map((claim) => (
        <ResultRow key={claim._id}>
          <div>
            <strong>{claim.from_id}</strong>
            {` — ${claim.fullNameMainPassenger()} · ${claim.jurisdiction || 'juridiction ?'} · ${claim.airport_departure} → ${claim.airport_arrival} · ${claim.ca_name_operated || claim.ca_name} · `}
            {claim.flight_date ? format(new Date(claim.flight_date), 'dd/MM/yyyy') : '—'}
            {` · ${claim.passengers.length} pax · ${(claim.compensation_total || 0).toLocaleString('fr-FR')} € `}
            {!isClaimSaisineReady(claim) && <Lozenge text="pax incomplets" red />}
          </div>
          <ButtonCustom text="Créer la saisine" onClick={() => create([claim._id])} />
        </ResultRow>
      ))}
      {!loading && text && !eligibleClaims.length
        && <Text color="secondary" variant="body2">Aucun dossier éligible pour cette recherche.</Text>}
    </PanelContainer>
  );
};

const PanelContainer = styled.div`
  border: 1px solid #dfe1e6;
  border-radius: 4px;
  padding: 15px;
  margin: 10px 0 20px 0;
`;

const SearchInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  margin: 10px 0;
  padding: 8px 10px;
  border: 1px solid #dfe1e6;
  border-radius: 4px;
  font-size: 14px;
`;

const ResultRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-bottom: 1px solid #f4f5f7;
  font-size: 13px;
`;

export {
  CreateSaisine,
};
